/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AggregateData } from '../model/aggregateData';
import { AntibioticsSummaryOrder } from '../model/antibioticsSummaryOrder';
import { ApiRequestDto } from '../model/apiRequestDto';
import { MedicationSummaryCountResult } from '../model/medicationSummaryCountResult';
import { MedicationSummaryResidentContainer } from '../model/medicationSummaryResidentContainer';
import { ResidentCountResult } from '../model/residentCountResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AntibioticSummaryService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Antibiotics by drug group (category).
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of antibiotics that facility has that belongs to that drug group.          Sample Call      http://URL/api/Antibiotics/GetAntibioticByDrugGroup
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticByDrugGroup(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetAntibioticByDrugGroup(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticByDrugGroup(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticByDrugGroup(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetAntibioticByDrugGroup`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Antibiotics grouped by facility
     * Queries Antibiotics and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/Antibiotics/GetAntibioticByFacility
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticByFacility(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetAntibioticByFacility(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticByFacility(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticByFacility(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetAntibioticByFacility`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Antibiotics grouped by prescriber.
     * This should be used only when a single org unit is selected in the UI.  When multiple org units are selected this call can&#39;t be used  and a different call should be used.    Results will be grouped by Drug Group and then within each group the top 4 prescribers with the 5th being \&quot;Other if there are more than   5 unique prescribers        Sample Call      http://URL/api/Antibiotics/GetAntibioticByPrescriber?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;590
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational unit to get data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetAntibioticByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticByPrescriber(startDate: string, endDate: string, orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling antibioticSummaryGetAntibioticByPrescriber.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling antibioticSummaryGetAntibioticByPrescriber.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling antibioticSummaryGetAntibioticByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetAntibioticByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for AntiBiotics (Grid Data).
     * Data in this call is not aggregated.        Sample Call      http://URL/api/Antibiotics/GetAntibioticData
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticData(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public antibioticSummaryGetAntibioticData(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetAntibioticData(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetAntibioticData(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticData.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Antibiotics/GetAntibioticData`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Grid data of Antibiotic orders with no stop date
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Antibiotics/AntibioticOrdersWithNoStopDate
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticOrdersWithNoStopDate(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDate(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDate(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDate(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticOrdersWithNoStopDate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Antibiotics/AntibioticOrdersWithNoStopDate`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Antibiotic orders with no stop date by Drug Group
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Antibiotics/GetAntibioticOrdersWithNoStopDateByDrugGroup
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticOrdersWithNoStopDateByDrugGroup(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDateByDrugGroup(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDateByDrugGroup(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDateByDrugGroup(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticOrdersWithNoStopDateByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetAntibioticOrdersWithNoStopDateByDrugGroup`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Antibiotic orders with no stop date by Facility
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Antibiotics/GetAntibioticOrdersWithNoStopDateByFacility
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticOrdersWithNoStopDateByFacility(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDateByFacility(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDateByFacility(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDateByFacility(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticOrdersWithNoStopDateByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetAntibioticOrdersWithNoStopDateByFacility`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Antibiotic orders with no stop date by prescriber
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Antibiotics/GetAntibioticOrdersWithNoStopDateByPrescriber
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticOrdersWithNoStopDateByPrescriber(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDateByPrescriber(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDateByPrescriber(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDateByPrescriber(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticOrdersWithNoStopDateByPrescriber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetAntibioticOrdersWithNoStopDateByPrescriber`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Antibiotic orders with no stop date by Facility
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Antibiotics/GetAntibioticOrdersWithNoStopDatePercentage
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticOrdersWithNoStopDatePercentage(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryCountResult>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDatePercentage(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryCountResult>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDatePercentage(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryCountResult>>;
    public antibioticSummaryGetAntibioticOrdersWithNoStopDatePercentage(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticOrdersWithNoStopDatePercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryCountResult>(`${this.basePath}/api/Antibiotics/GetAntibioticOrdersWithNoStopDatePercentage`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of residents on Antibiotics
     * Percentage of total residents in the selected facilities against the number of residents on antibiotics in the selected date range                   Sample Call     http://URL/api/Antibiotics/GetAntibioticPercentage
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticPercentage(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public antibioticSummaryGetAntibioticPercentage(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public antibioticSummaryGetAntibioticPercentage(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public antibioticSummaryGetAntibioticPercentage(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/Antibiotics/GetAntibioticPercentage`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for Antibiotics .
     * This returns  Antibiotics with a stop date.  Data in this call is not aggregated.        Sample Call      http://URL/api/Antibiotics/GetAntibioticsWithDurationOfTherapy
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticsWithDurationOfTherapy(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapy(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapy(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapy(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticsWithDurationOfTherapy.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Antibiotics/GetAntibioticsWithDurationOfTherapy`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Antibiotics by drug group (category) with average duration.
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.           Sample Call      http://URL/api/Antibiotics/GetAntibioticsWithDurationOfTherapyByDrugGroup
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByDrugGroup(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByDrugGroup(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByDrugGroup(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByDrugGroup(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticsWithDurationOfTherapyByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetAntibioticsWithDurationOfTherapyByDrugGroup`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Antibiotics grouped by facility with average duration
     * Count of each group is stored in ItemCount        Sample Call      http://URL/api/Antibiotics/GetAntibioticsWithDurationOfTherapyByFacility
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByFacility(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByFacility(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByFacility(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByFacility(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticsWithDurationOfTherapyByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetAntibioticsWithDurationOfTherapyByFacility`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IV Antibiotics grouped by prescriber with average duration.
     * Sample Call  http://URL/api/Antibiotics/GetAntibioticsWithDurationOfTherapyByPrescriber?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;590
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational unit to get data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByPrescriber(startDate: string, endDate: string, orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling antibioticSummaryGetAntibioticsWithDurationOfTherapyByPrescriber.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling antibioticSummaryGetAntibioticsWithDurationOfTherapyByPrescriber.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling antibioticSummaryGetAntibioticsWithDurationOfTherapyByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetAntibioticsWithDurationOfTherapyByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Average duration broken down by Route Category
     * The average duration is in the ItemCount propery of each Subgroup  Sample Call  http://URL/api/Antibiotics/GetAntibioticsWithDurationOfTherapyByRouteCategory
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByRouteCategory(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByRouteCategory(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByRouteCategory(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetAntibioticsWithDurationOfTherapyByRouteCategory(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetAntibioticsWithDurationOfTherapyByRouteCategory.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetAntibioticsWithDurationOfTherapyByRouteCategory`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * CDifficile Antibiotics by drug group (category).
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of antibiotics that facility has that belongs to that drug group.          Sample Call      http://URL/api/Antibiotics/GetCDifficileAntibioticsByDrugGroup
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetCDifficileAntibioticsByDrugGroup(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetCDifficileAntibioticsByDrugGroup(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetCDifficileAntibioticsByDrugGroup(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetCDifficileAntibioticsByDrugGroup(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetCDifficileAntibioticsByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetCDifficileAntibioticsByDrugGroup`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * CDifficile Antibiotics grouped by facility
     * Queries Antibiotics and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/Antibiotics/GetCDifficileAntibioticsByFacility
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetCDifficileAntibioticsByFacility(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetCDifficileAntibioticsByFacility(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetCDifficileAntibioticsByFacility(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetCDifficileAntibioticsByFacility(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetCDifficileAntibioticsByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetCDifficileAntibioticsByFacility`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * CDifficile Antibiotics grouped by prescriber.
     * This should be used only when a single org unit is selected in the UI.  When multiple org units are selected this call can&#39;t be used  and a different call should be used.    Results will be grouped by Drug Group and then within each group the top 4 prescribers with the 5th being \&quot;Other if there are more than   5 unique prescribers        Sample Call      http://URL/api/Antibiotics/GetCDifficileAntibioticByPrescriber?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;590
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational unit to get data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetCDifficileAntibioticsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetCDifficileAntibioticsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetCDifficileAntibioticsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetCDifficileAntibioticsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling antibioticSummaryGetCDifficileAntibioticsByPrescriber.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling antibioticSummaryGetCDifficileAntibioticsByPrescriber.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling antibioticSummaryGetCDifficileAntibioticsByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetCDifficileAntibioticsByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for CDifficile Antibiotics (Grid Data).
     * This returns CDifficile Antibiotics.  Data in this call is not aggregated.        Sample Call      http://URL/api/Antibiotics/GetCDifficileAntibioticData
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetCDifficileAntibioticsData(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public antibioticSummaryGetCDifficileAntibioticsData(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetCDifficileAntibioticsData(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetCDifficileAntibioticsData(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetCDifficileAntibioticsData.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Antibiotics/GetCDifficileAntibioticsData`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of residents on CDifficile Antibiotics
     * Percentage of total residents in the selected facilities against the number of residents on IV antibiotics in the selected date range                   Sample Call     http://URL/api/Antibiotics/GetCDifficileAntibioticsPercentage
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetCDifficileAntibioticsPercentage(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public antibioticSummaryGetCDifficileAntibioticsPercentage(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public antibioticSummaryGetCDifficileAntibioticsPercentage(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public antibioticSummaryGetCDifficileAntibioticsPercentage(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetCDifficileAntibioticsPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/Antibiotics/GetCDifficileAntibioticsPercentage`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * External Antibiotics Greater than 30 days grid data.
     * Sample Call  http://URL/api/Antibiotics/GetExternalAntibioticsGreaterThan30Days
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetExternalAntibioticsGreaterThan30Days(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30Days(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30Days(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30Days(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetExternalAntibioticsGreaterThan30Days.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Antibiotics/GetExternalAntibioticsGreaterThan30Days`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * External Antibiotics Greater than 30 days by Facility
     * Sample Call  http://URL/api/Antibiotics/GetExternalAntibioticsGreaterThan30DaysByFacility
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByFacility(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByFacility(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByFacility(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByFacility(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetExternalAntibioticsGreaterThan30DaysByFacility`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * External Antibiotics Greater than 30 days by Prescriber
     * Sample Call  http://URL/api/Antibiotics/GetExternalAntibioticsGreaterThan30DaysByPrescriber
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByPrescriber(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByPrescriber(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByPrescriber(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByPrescriber(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByPrescriber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetExternalAntibioticsGreaterThan30DaysByPrescriber`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * External Antibiotics Greater than 30 days by Route
     * Sample Call  http://URL/api/Antibiotics/GetExternalAntibioticsGreaterThan30DaysByRoute
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByRoute(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByRoute(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByRoute(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByRoute(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetExternalAntibioticsGreaterThan30DaysByRoute.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetExternalAntibioticsGreaterThan30DaysByRoute`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * External Antibiotics Greater than 30 days by Prescriber
     * Sample Call  http://URL/api/Antibiotics/GetExternalAntibioticsGreaterThan30DaysPercentage
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysPercentage(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryCountResult>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysPercentage(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryCountResult>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysPercentage(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryCountResult>>;
    public antibioticSummaryGetExternalAntibioticsGreaterThan30DaysPercentage(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetExternalAntibioticsGreaterThan30DaysPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryCountResult>(`${this.basePath}/api/Antibiotics/GetExternalAntibioticsGreaterThan30DaysPercentage`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for IV and oral Antibiotics Over 14 days (Grid Data).
     * This returns Antibiotics.  Data in this call is not aggregated.        Sample Call      http://URL/api/Antibiotics/GetIVandOralAntibioticsOver14Days
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetIVandOralAntibioticsOver14Days(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public antibioticSummaryGetIVandOralAntibioticsOver14Days(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14Days(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14Days(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetIVandOralAntibioticsOver14Days.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Antibiotics/GetIVandOralAntibioticsOver14Days`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IV and oral antibiotics over 14 Days by drug group (category).
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of antibiotics that facility has that belongs to that drug group.          Sample Call      http://URL/api/Antibiotics/GetIVandOralAntibioticsOver14DaysByDrugGroup
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysByDrugGroup(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysByDrugGroup(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysByDrugGroup(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysByDrugGroup(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetIVandOralAntibioticsOver14DaysByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetIVandOralAntibioticsOver14DaysByDrugGroup`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IV and Oral Antibiotics over 14 days grouped by facility
     * Queries Antibiotics and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/Antibiotics/GetIVandOralAntibioticsOver14DaysByFacility
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysByFacility(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysByFacility(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysByFacility(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysByFacility(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetIVandOralAntibioticsOver14DaysByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetIVandOralAntibioticsOver14DaysByFacility`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IV and oral antibiotics over 14 Days grouped by prescriber.
     * This should be used only when a single org unit is selected in the UI.  When multiple org units are selected this call can&#39;t be used  and a different call should be used.    Results will be grouped by Drug Group and then within each group the top 4 prescribers with the 5th being \&quot;Other if there are more than   5 unique prescribers        Sample Call      http://URL/api/Antibiotics/GetIVandOralAntibioticsOver14DaysByPrescriber?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;590
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational unit to get data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysByPrescriber(startDate: string, endDate: string, orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling antibioticSummaryGetIVandOralAntibioticsOver14DaysByPrescriber.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling antibioticSummaryGetIVandOralAntibioticsOver14DaysByPrescriber.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling antibioticSummaryGetIVandOralAntibioticsOver14DaysByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetIVandOralAntibioticsOver14DaysByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of orders that are IV or Oral Antibiotics over 14 days
     * Percentage of the number of orders on IV and Oral antibiotics over 14 days against antibiotic orders in the selected facilities                   Sample Call     http://URL/api/Antibiotics/GetIVandOralAntibioticsOver14DaysPercentage
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysPercentage(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryCountResult>;
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysPercentage(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryCountResult>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysPercentage(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryCountResult>>;
    public antibioticSummaryGetIVandOralAntibioticsOver14DaysPercentage(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetIVandOralAntibioticsOver14DaysPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryCountResult>(`${this.basePath}/api/Antibiotics/GetIVandOralAntibioticsOver14DaysPercentage`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IV Antibiotics by drug group (category).
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of antibiotics that facility has that belongs to that drug group.          Sample Call      http://URL/api/Antibiotics/GetIvAntibioticsByDrugGroup
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetIvAntibioticsByDrugGroup(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetIvAntibioticsByDrugGroup(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetIvAntibioticsByDrugGroup(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetIvAntibioticsByDrugGroup(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetIvAntibioticsByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetIvAntibioticsByDrugGroup`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IV Antibiotics grouped by facility
     * Queries Antibiotics and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/Antibiotics/GetIvAntibioticsByFacility
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetIvAntibioticsByFacility(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetIvAntibioticsByFacility(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetIvAntibioticsByFacility(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetIvAntibioticsByFacility(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetIvAntibioticsByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetIvAntibioticsByFacility`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IV Antibiotics grouped by prescriber.
     * This should be used only when a single org unit is selected in the UI.  When multiple org units are selected this call can&#39;t be used  and a different call should be used.    Results will be grouped by Drug Group and then within each group the top 4 prescribers with the 5th being \&quot;Other if there are more than   5 unique prescribers        Sample Call      http://URL/api/Antibiotics/GetIvAntibioticByPrescriber?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;590
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational unit to get data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetIvAntibioticsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetIvAntibioticsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetIvAntibioticsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetIvAntibioticsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling antibioticSummaryGetIvAntibioticsByPrescriber.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling antibioticSummaryGetIvAntibioticsByPrescriber.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling antibioticSummaryGetIvAntibioticsByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetIvAntibioticsByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for IV Antibiotics (Grid Data).
     * This returns IV Antibiotics.  Data in this call is not aggregated.        Sample Call      http://URL/api/Antibiotics/GetIvAntibioticData
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetIvAntibioticsData(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public antibioticSummaryGetIvAntibioticsData(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetIvAntibioticsData(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetIvAntibioticsData(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetIvAntibioticsData.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Antibiotics/GetIvAntibioticsData`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of residents on IV Antibiotics
     * Percentage of total residents in the selected facilities against the number of residents on IV antibiotics in the selected date range                   Sample Call     http://URL/api/Antibiotics/GetIvAntibioticsPercentage
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetIvAntibioticsPercentage(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public antibioticSummaryGetIvAntibioticsPercentage(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public antibioticSummaryGetIvAntibioticsPercentage(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public antibioticSummaryGetIvAntibioticsPercentage(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetIvAntibioticsPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/Antibiotics/GetIvAntibioticsPercentage`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Possible conversion Antibiotics by drug name
     * Displays top 4 drug names with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of antibiotics that facility has that belongs to that drug group.          Sample Call      http://URL/api/Antibiotics/GetPossibleConversionAntibioticsByDrugName
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetPossibleConversionAntibioticsByDrugName(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetPossibleConversionAntibioticsByDrugName(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetPossibleConversionAntibioticsByDrugName(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetPossibleConversionAntibioticsByDrugName(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetPossibleConversionAntibioticsByDrugName.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetPossibleConversionAntibioticsByDrugName`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Possible conversion antibiotics grouped by facility
     * Queries Antibiotics and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/Antibiotics/GetPossibleConversionAntibioticsByFacility
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetPossibleConversionAntibioticsByFacility(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetPossibleConversionAntibioticsByFacility(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetPossibleConversionAntibioticsByFacility(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetPossibleConversionAntibioticsByFacility(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetPossibleConversionAntibioticsByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetPossibleConversionAntibioticsByFacility`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Possible conversion Antibiotics grouped by prescriber.
     * This should be used only when a single org unit is selected in the UI.  When multiple org units are selected this call can&#39;t be used  and a different call should be used.    Results will be grouped by Drug Group and then within each group the top 4 prescribers with the 5th being \&quot;Other if there are more than   5 unique prescribers        Sample Call      http://URL/api/Antibiotics/GetPossibleConversionAntibioticByPrescriber?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;590
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational unit to get data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetPossibleConversionAntibioticsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetPossibleConversionAntibioticsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetPossibleConversionAntibioticsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetPossibleConversionAntibioticsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling antibioticSummaryGetPossibleConversionAntibioticsByPrescriber.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling antibioticSummaryGetPossibleConversionAntibioticsByPrescriber.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling antibioticSummaryGetPossibleConversionAntibioticsByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/GetPossibleConversionAntibioticsByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for possible conversion Antibiotics (Grid Data).
     * This returns possible conversion Antibiotics.  Data in this call is not aggregated.        Sample Call      http://URL/api/Antibiotics/GetPossibleConversionAntibioticData
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetPossibleConversionAntibioticsData(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public antibioticSummaryGetPossibleConversionAntibioticsData(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetPossibleConversionAntibioticsData(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetPossibleConversionAntibioticsData(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetPossibleConversionAntibioticsData.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Antibiotics/GetPossibleConversionAntibioticsData`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of residents on possible conversion Antibiotics
     * Percentage of total residents in the selected facilities against the number of residents on IV antibiotics in the selected date range                   Sample Call     http://URL/api/Antibiotics/GetPossibleConversionAntibioticsPercentage
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetPossibleConversionAntibioticsPercentage(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public antibioticSummaryGetPossibleConversionAntibioticsPercentage(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public antibioticSummaryGetPossibleConversionAntibioticsPercentage(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public antibioticSummaryGetPossibleConversionAntibioticsPercentage(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetPossibleConversionAntibioticsPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/Antibiotics/GetPossibleConversionAntibioticsPercentage`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Grid Data for Residents that have more than one Antibiotic
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Antibiotics/ResidentsWithMultipleAntibiotics
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetResidentsWithMultipleAntibiotics(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public antibioticSummaryGetResidentsWithMultipleAntibiotics(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetResidentsWithMultipleAntibiotics(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public antibioticSummaryGetResidentsWithMultipleAntibiotics(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetResidentsWithMultipleAntibiotics.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Antibiotics/ResidentsWithMultipleAntibiotics`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Residents that have more than one Antibiotic by prescriber
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Antibiotics/ResidentsWithMultipleAntibioticsByDrugOrder
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetResidentsWithMultipleAntibioticsByDrugOrder(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AntibioticsSummaryOrder>>;
    public antibioticSummaryGetResidentsWithMultipleAntibioticsByDrugOrder(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AntibioticsSummaryOrder>>>;
    public antibioticSummaryGetResidentsWithMultipleAntibioticsByDrugOrder(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AntibioticsSummaryOrder>>>;
    public antibioticSummaryGetResidentsWithMultipleAntibioticsByDrugOrder(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetResidentsWithMultipleAntibioticsByDrugOrder.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AntibioticsSummaryOrder>>(`${this.basePath}/api/Antibiotics/ResidentsWithMultipleAntibioticsByDrugOrder`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Residents that have more than one Antibiotic by prescriber
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Antibiotics/ResidentsWithMultipleAntibioticsByFacility
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetResidentsWithMultipleAntibioticsByFacility(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetResidentsWithMultipleAntibioticsByFacility(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetResidentsWithMultipleAntibioticsByFacility(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetResidentsWithMultipleAntibioticsByFacility(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetResidentsWithMultipleAntibioticsByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/ResidentsWithMultipleAntibioticsByFacility`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Residents that have more than one Antibiotic by prescriber
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Antibiotics/ResidentsWithMultipleAntibioticsByPrescriber
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetResidentsWithMultipleAntibioticsByPrescriber(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public antibioticSummaryGetResidentsWithMultipleAntibioticsByPrescriber(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public antibioticSummaryGetResidentsWithMultipleAntibioticsByPrescriber(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public antibioticSummaryGetResidentsWithMultipleAntibioticsByPrescriber(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetResidentsWithMultipleAntibioticsByPrescriber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Antibiotics/ResidentsWithMultipleAntibioticsByPrescriber`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of Residents that have more than one Antibiotic
     * Sample Call  http://URL/api/Antibiotics/GetResidentsWithMultipleAntibioticsPercentage
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public antibioticSummaryGetResidentsWithMultipleAntibioticsPercentage(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public antibioticSummaryGetResidentsWithMultipleAntibioticsPercentage(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public antibioticSummaryGetResidentsWithMultipleAntibioticsPercentage(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public antibioticSummaryGetResidentsWithMultipleAntibioticsPercentage(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling antibioticSummaryGetResidentsWithMultipleAntibioticsPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/Antibiotics/GetResidentsWithMultipleAntibioticsPercentage`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
